var map = {
	"./pin_exchange_blue.svg": "100b",
	"./pin_exchange_green.svg": "806e",
	"./pin_exchange_orange.svg": "ffda",
	"./pin_exchange_purple.svg": "235b",
	"./pin_exchange_red.svg": "8ed2",
	"./pin_substitution_blue.svg": "3097",
	"./pin_substitution_green.svg": "3f09",
	"./pin_substitution_orange.svg": "e0ea",
	"./pin_substitution_purple.svg": "9c8d",
	"./pin_substitution_red.svg": "78ea",
	"./pin_take_away_blue.svg": "dd7e",
	"./pin_take_away_green.svg": "a46d",
	"./pin_take_away_orange.svg": "511c",
	"./pin_take_away_purple.svg": "be8c",
	"./pin_take_away_red.svg": "48c3",
	"./pin_transport_blue.svg": "5870",
	"./pin_transport_green.svg": "1e94",
	"./pin_transport_orange.svg": "df2e",
	"./pin_transport_purple.svg": "d614",
	"./pin_transport_red.svg": "b538"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b165";